"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./FilterSection.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _FilterSectionMethods = require("./FilterSectionMethods");
var _useClickListener = _interopRequireDefault(require("../../utils/hooks/useClickListener"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FilterSection = _ref => {
  let {
    content
  } = _ref;
  const {
    introSection,
    allFilters,
    filtersTitle,
    filterOptionClickHandler,
    activeFilters,
    clearAllFiltersHandler,
    removeActiveFilterHandler,
    showRSSFeed = false,
    rssFeedButton
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  const [hoveredItem, setHoveredItem] = (0, _react.useState)(null);
  const [openFilterDropdown, setOpenFilterDropdown] = (0, _react.useState)(null); // controls which filter dropdown is open
  const [filtersCollapsed, setFiltersCollapsed] = (0, _react.useState)(false);
  const [copyTextVisible, setCopyTextVisible] = (0, _react.useState)(false);
  const collapseWrapperRef = (0, _react.useRef)(null);
  const handleFilterDropdownClick = (e, filter) => {
    if (!e?.target?.classList.contains('ter-checkbox__label') && openFilterDropdown === filter) {
      // if clicked dropdown is already open, close it
      setOpenFilterDropdown(null);
    } else {
      setOpenFilterDropdown(filter);
    }
  };
  const handleOptionHover = (e, option) => {
    setHoveredItem(option);
  };
  const handleCloseDropdown = e => {
    e.stopPropagation();
    if (!(e?.target?.classList?.contains('ter-filter-section__filter-label') || e?.target?.classList?.contains('ter-filter-section__filter-placeholder') || e?.target?.classList?.contains('ter-filter-section__filter-list') || e?.target?.classList?.contains('ter-checkbox__label') || e?.target?.classList?.contains('ter-checkbox') || e?.target?.classList?.contains('ter-filter-section__filter-checkbox'))) {
      setOpenFilterDropdown(null);
    }
  };
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  (0, _react.useEffect)(() => {
    if (width <= 600) {
      setFiltersCollapsed(true);
    } else {
      setFiltersCollapsed(false);
    }
  }, [width]);
  const filtersWrapperHeight = !filtersCollapsed ? collapseWrapperRef?.current?.clientHeight + 14 + "px" : "0";
  let query = "";
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".ter-filter-section__filter-placeholder").length > 0;
  }
  (0, _useClickListener.default)(handleCloseDropdown, query);
  const rssClickHandler = (e, url) => {
    navigator?.clipboard?.writeText(url);
    setCopyTextVisible(true);
    setTimeout(() => {
      setCopyTextVisible(false);
    }, 2000);
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-filter-section"
  }, introSection && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__intro"
  }, introSection), allFilters?.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-button ter-button--primary--2 ter-filter-section__collapse-button",
    onClick: e => {
      setFiltersCollapsed(!filtersCollapsed);
    }
  }, filtersCollapsed ? 'Show Filters' : 'Hide Filters'), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-filter-section__collapse-wrapper`,
    style: {
      maxHeight: filtersWrapperHeight,
      overflow: filtersCollapsed ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: collapseWrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__title"
  }, /*#__PURE__*/_react.default.createElement("h4", null, filtersTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__outer "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-filter-section__filters ${showRSSFeed === true ? "ter-filter-section__filters--with-rss" : ""}`
  }, (0, _FilterSectionMethods.renderFiltersSection)(allFilters, handleFilterDropdownClick, filterOptionClickHandler, openFilterDropdown, activeFilters, handleOptionHover, hoveredItem), activeFilters?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__clear"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-filter-section__clear-button",
    onClick: e => clearAllFiltersHandler(e)
  }, "Clear all filters"))), showRSSFeed && rssFeedButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__rss-button"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-button ter-button--primary--1",
    onClick: e => rssClickHandler(e, rssFeedButton?.url)
  }, rssFeedButton?.text), /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-filter-section__copied-text ${copyTextVisible ? `ter-filter-section__copied-text--visible` : ''}`
  }, rssFeedButton?.copyText))))), showRSSFeed && rssFeedButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__rss-button ter-filter-section__rss-button--mobile"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-button ter-button--primary--1",
    onClick: e => rssClickHandler(e, rssFeedButton?.url)
  }, rssFeedButton?.text), /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-filter-section__copied-text ${copyTextVisible ? `ter-filter-section__copied-text--visible` : ''}`
  }, rssFeedButton?.copyText)), activeFilters?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-section__chips"
  }, (0, _FilterSectionMethods.renderActiveFilters)(activeFilters, removeActiveFilterHandler))));
};
var _default = FilterSection;
exports.default = _default;